import React, { useState, useEffect } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";

const initialState = {
  id: 0,
  userId: 0,
  plan: "",
  amount: "",
  paymentMode: "",
  paymentParticulars: "",
  expiryDate: "",
};

const SubscriptionForm = ({ onSave, initialData, readOnly }) => {
  const [subscription, setSubscription] = useState(initialState);

  // Load initial data if provided (Edit mode)
  useEffect(() => {
    if (initialData) {
      setSubscription({ ...initialData });
    } else {
      setSubscription(initialState);
    }
  }, [initialData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSubscription((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(subscription);
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Row className="mb-3">
        <Col md={4}>
          <Form.Group controlId="userId">
            <Form.Label>User Id</Form.Label>
            <Form.Control
              type="number"
              name="userId"
              value={subscription.userId}
              onChange={handleChange}
              disabled={readOnly}
              required
            />
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group controlId="plan">
            <Form.Label>Plan</Form.Label>
            <Form.Control
              type="text"
              name="plan"
              value={subscription.plan}
              onChange={handleChange}
              disabled={readOnly}
              required
            />
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group controlId="amount">
            <Form.Label>Amount</Form.Label>
            <Form.Control
              type="number"
              name="amount"
              value={subscription.amount}
              onChange={handleChange}
              disabled={readOnly}
              required
            />
          </Form.Group>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col md={4}>
          <Form.Group controlId="paymentMode">
            <Form.Label>Payment Mode</Form.Label>
            <Form.Control
              type="text"
              name="paymentMode"
              value={subscription.paymentMode}
              onChange={handleChange}
              disabled={readOnly}
              required
            />
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group controlId="paymentParticulars">
            <Form.Label>Payment Particulars</Form.Label>
            <Form.Control
              type="text"
              name="paymentParticulars"
              value={subscription.paymentParticulars}
              onChange={handleChange}
              disabled={readOnly}
              required
            />
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group controlId="expiryDate">
            <Form.Label>Expiry Date</Form.Label>
            <Form.Control
              type="date"
              name="expiryDate"
              value={subscription.expiryDate}
              onChange={handleChange}
              disabled={readOnly}
              required
            />
          </Form.Group>
        </Col>
      </Row>

      {!readOnly && (
        <Row>
          <Col>
            <Button type="submit" className="me-2">
              Save
            </Button>
            <Button
              variant="secondary"
              onClick={() => setSubscription(initialState)}
            >
              Clear
            </Button>
          </Col>
        </Row>
      )}
    </Form>
  );
};

export default SubscriptionForm;
